import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import DatePicker from '@adsk/bim360-matrix-react-date-picker';
import DateSelector from '@adsk/bim360-matrix-react-date-selector';
import {WithScrollableContainerRef} from '@adsk/bim360-matrix-react-helpers';
import {toUtcLongDate, toIsoDate, fromDateSelectorDate} from '../../utils/date-helpers';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const DueDateToInlineEdit = ({issue, className, styleType, isRequired}) => (
  <IssueFieldInlineEdit
    issue={issue}
    attributeName={ISSUE_ATTRIBUTE_NAMES.DUE_DATE}
    label={i18n.t('new.dueDate')}
    getDisplayValue={currentValue => (currentValue ? toUtcLongDate(currentValue) : '')}
    placeholder={i18n.t('dueDate.unspecified')}
    className={className}
    data-testid="DueDateInlineEdit"
    styleType={styleType}
    isRequired={isRequired}
  >
    {(currentValue, closeEditMode, updateIssue) => {
      if (featureFlags.get(FEATURE_FLAGS.DATE_SELECTOR)) {
        const nodeList = document.getElementsByClassName('IssuePreview__content');
        return (
          <DateSelector
            defaultOpen
            inputProps={{
              placeholder: i18n.t('dueDate.unspecified')
            }}
            popupProps={{
              disablePastDates: true,
              canClear: !isRequired
            }}
            date={currentValue ? new Date(currentValue) : null}
            popupContainer={nodeList && nodeList[0]}
            onClose={closeEditMode}
            onChange={({date}) => {
              const newValue = fromDateSelectorDate(date);
              updateIssue(newValue);
            }}
          />
        );
      } else {
        const DatePickerWithContainer = WithScrollableContainerRef(DatePicker, 'IssuePreview__content');
        return (
          <DatePickerWithContainer
            hideClearDateButton={isRequired}
            openOnMount
            disablePastDates
            placeholder={i18n.t('dueDate.unspecified')}
            date={currentValue ? new Date(currentValue) : null}
            onClickOutside={closeEditMode}
            onChange={newMomentValue => {
              const newValue = toIsoDate(newMomentValue);
              updateIssue(newValue);
            }}
          />
        );
      }
    }}
  </IssueFieldInlineEdit>
);

DueDateToInlineEdit.displayName = 'DueDateToInlineEdit';

DueDateToInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  isRequired: PropTypes.bool
};

export default DueDateToInlineEdit;
